import IMask from "imask";

export const initPhoneMask = () => {
  const inputs = document.querySelectorAll<HTMLInputElement>('input[type="tel"]');

  if (inputs.length > 0) {
    inputs.forEach(($input) => {
      IMask($input, {
        mask: "+{1} (000) 000-0000",
      });
    });
  }
};
